module.exports = require("leaflet.offline");